import React from "react";
import { ReactController } from "../react_controller";
import { FacilitiesMatrix } from "../../components/Calendar/FacilitiesMatrix";

export class AdminFacilitiesMatrixController extends ReactController {
  connect() {
    this.root.render(<FacilitiesMatrix {...this.propsValue} />);
  }
}
